import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../shared';
import { ProdutividadeFilterModule } from '../../components/filter';

import { ProdutividadeViewComponent } from './produtividade-view.component';

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        ProdutividadeFilterModule
    ],
    declarations: [
        ProdutividadeViewComponent
    ],
    exports: [
        ProdutividadeViewComponent
    ]
})
export class ProdutividadeViewModule { }
